(function()
{
    // Library depencencies
    var DebugOptions = include('springroll.DebugOptions', false),
        TitleState = include('WGBH.TitleState'),
        GameState = include('WGBH.GameState'),
        Application = include('springroll.Application'),
        Transition = include('lib.Transition'),
        Display = include('springroll.easeljs.EaselJSDisplay');
        
    var app = new Application({
        fps: 15,
        name: 'Don\'t Wake Kate',
        state: 'title',
        canvasId: 'stage',
        configPath: 'assets/config/config.json',
        manifestsPath: 'assets/config/manifests.json',
        transition: new Transition(),
        display: Display,
        displayOptions: {
            clearView: true,
        }
    });

    var version;

    // Log out the qeury options
    if (DEBUG && DebugOptions)
    {
        DebugOptions
            .string('state', 'title, game')
            .boolean('mute', 'mute all sounds')
            .log();
    }

    // App has been initialized
    app.on('init', function()
    {
        var assets = this.config.assets;
        var scaling = this.config.scaling;
        var fla = this.manifests;

        // Set the states to use
        this.states = {
            title: new TitleState({
                next: 'game',
                preload: assets.title,
                scaling: scaling.title
            }),
            game: new GameState({
                preload: assets.game,
                scaling: "panel"
            })
        };
   
    });

    // Give window access to the app
    window.app = app;


}());
